import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Templates from '@/pages/Templates';
import Editor from '@/pages/Editor';
import Dashboard from '@/pages/Dashboard';
import Login from '@/pages/Login';
import Pricing from '@/pages/Pricing';
import Account from '@/pages/Account';
import PublicResume from '@/pages/PublicResume';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navbar />
      <main className="pt-16">{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/templates" element={<Layout><Templates /></Layout>} />
          <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/account" element={<Layout><Account /></Layout>} />
          <Route path="/r/:slug" element={<PublicResume />} />
          <Route path="/editor/:templateId" element={<Editor />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
